import { remSize } from '../../../constants';

export const gridLayoutMargin: [number, number] = [remSize, remSize];
